<template>
  <div
    class="modal fade"
    id="add_item"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? "Update" : "Create" }} {{ title }}
          </h5>
          <div class="d-flex align-items-center">
            <button
              class="btn-close custom-btn-close border p-1 me-0 text-dark"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="ti ti-x"></i>
            </button>
          </div>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <!-- Input Fields -->
            <div class="mb-3">
              <label class="col-form-label">Company Name</label>
              <input type="text" class="form-control" v-model="CompanyName" />
              <div class="text-danger" v-if="errors.CompanyName">
                {{ errors.CompanyName[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Person Name <span class="text-danger">*</span></label
              >
              <input type="text" class="form-control" v-model="PersonName" />
              <div class="text-danger" v-if="errors.PersonName">
                {{ errors.PersonName[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Designation</label>
              <input type="text" class="form-control" v-model="Designation" />
              <div class="text-danger" v-if="errors.Designation">
                {{ errors.Designation[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Contact Email <span class="text-danger">*</span></label
              >
              <input type="email" class="form-control" v-model="ContactEmail" />
              <div class="text-danger" v-if="errors.ContactEmail">
                {{ errors.ContactEmail[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Contact Number</label>
              <input type="text" class="form-control" v-model="ContactNumber" />
              <div class="text-danger" v-if="errors.ContactNumber">
                {{ errors.ContactNumber[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label"
                >Date of Birth <span class="text-danger">*</span></label
              >
              <Datepicker
                v-model="DOB"
                :clearable="true"
                :format="format"
                placeholder="Select a date"
              />
              <div class="text-danger" v-if="errors.DOB">
                {{ errors.DOB[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Address</label>
              <input type="text" class="form-control" v-model="Address" />
              <div class="text-danger" v-if="errors.Address">
                {{ errors.Address[0] }}
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex align-items-center justify-content-end m-0">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                type="submit"
                class="btn btn-primary"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                {{ isEditMode ? "Update" : "Create" }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Add  -->
  <!-- Delete -->
  <div class="modal fade" id="delete_item" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <div class="text-center">
            <div class="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i class="ti ti-trash-x fs-36 text-danger"></i>
            </div>
            <h4 class="mb-2">Remove {{ title }}?</h4>
            <p class="mb-0">Are you sure you want to remove it</p>
            <div class="d-flex align-items-center justify-content-center mt-4">
              <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal"
                >Cancel</a
              >
              <button
                class="btn btn-danger"
                @click="deleteItem()"
                :disabled="isLoading"
              >
                <span
                  v-if="isLoading"
                  class="spinner-border spinner-border-sm"
                ></span>
                Yes, Delete it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/http";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  components: { Datepicker },
  props: {
    isEditMode: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    isLoading: false,
    format: "yyyy-MM-dd",
    itemId: null,
    CompanyName: "",
    PersonName: "",
    Designation: "",
    ContactEmail: "",
    ContactNumber: "",
    DOB: "",
    Address: "",
    errors: {},
  }),

  mounted() {
    this.$emitter.on("add-edit-item", (row) => {
      this.errors = {};
      if (row) {
        this.itemId = row.id;
        this.CompanyName = row.CompanyName;
        this.PersonName = row.PersonName;
        this.Designation = row.Designation;
        this.ContactEmail = row.ContactEmail;
        this.ContactNumber = row.ContactNumber;
        this.DOB = row?.DOB;
        this.Address = row.Address;
      } else {
        this.itemId = null;
        this.CompanyName = "";
        this.PersonName = "";
        this.Designation = "";
        this.ContactEmail = "";
        this.ContactNumber = "";
        this.DOB = "";
        this.Address = "";
      }
      this.$handleModal("add_item", "toggle");
    });

    this.$emitter.on("delete-item-modal", (row) => {
      if (row) {
        this.itemId = row.id;
      }
      this.$handleModal("delete_item", "toggle");
    });
  },

  methods: {
    async submitForm() {
      this.isLoading = true;

      const endpoint = "/birthday-wish/save";
      let body = {
        CompanyName: this.CompanyName,
        PersonName: this.PersonName,
        Designation: this.Designation,
        ContactEmail: this.ContactEmail,
        ContactNumber: this.ContactNumber,
        DOB: this.DOB,
        Address: this.Address,
      };

      if (this.isEditMode && this.itemId) {
        body.id = this.itemId;
      }

      try {
        const response = await http.post(endpoint, body);

        this.$toast.success(response.data.message);
        this.$handleModal("add_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.errors = error.response?.data?.errors || {};
      } finally {
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      const endpoint = `/birthday-wish/${this.itemId}`;
      const method = "delete";
      try {
        const response = await http[method](endpoint);
        this.$toast.success(response.data.message);
        this.$handleModal("delete_item", "hide");
        this.$emit("refresh");
      } catch (error) {
        this.$toast.error(error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
